export enum PolicyStatusEnum {
  All = "all",
  Active = "active",
  Inactive = "inactive",
}
